let advantagesBlock = document.querySelector('section.advantages')

if(advantagesBlock) {
    let items = advantagesBlock.querySelectorAll('.advantage-item')
    let image = advantagesBlock.querySelectorAll('.image')
    let text = advantagesBlock.querySelectorAll('.text')

    for(let item of items) {
        item.select = () => {
            let index = item.index()
            let siblings = item.siblings()
            let itemImage = image[index]
            let imageSiblings = itemImage.siblings()
            let itemText = text[index]
            let textSiblings = itemText.siblings()

            item.classList.add('active')
            itemImage.classList.add('active')
            itemText.classList.add('active')

            for(let sibling of siblings) {
                sibling.classList.remove('active')
            }

            for(let sibling of imageSiblings) {
                sibling.classList.remove('active')
            }

            for(let sibling of textSiblings) {
                sibling.classList.remove('active')
            }
        }

        item.addEventListener('mouseenter', item.select)
    }
}